function BasketPageClickEvents() {
    // #region BasketItems
    $(document).on("keyup", ".OrderBasketContainer .Quantity input.sepetAdet", function () {
        var basketID = $(this).attr("data-id");
        Input = $(this);
        var Amount = $(this).val();
        var LangID = $("#LangID").val();

        if (Amount <= 1) {
            $(this).val(1);
            Amount = 1;
        }
        else if (Amount >= 9) {
            $(this).val(9);
            Amount = 9;
        }

        UpdateCartAmount(basketID, Amount, LangID, function (dt, msg) {
            if (dt == true) {
                GetBasketItems();
                GiftPackageControl();
                RefreshOrderSummary();
            }
            else {
                GenerateLocalLoading($(".OrderBasketContainer"), "hide");
                SwalGenerate("error", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));

                Input.val(parseInt(AmountInput.val()) - 1);
            }
        });
    });

    $(document).on("click", ".OrderBasketContainer .Quantity .GenMinus, .OrderBasketContainer .Quantity .GenPlus", function () {
        AmountInput = $(this).parent().children(".sepetAdet");

        if ($(this).hasClass("GenPlus") == true) {
            AmountInput.val(parseInt(AmountInput.val()) + 1);
        }
        else {
            AmountInput.val(parseInt(AmountInput.val()) - 1);
        }

        if (AmountInput.val() > 0) {
            AmountInput.trigger('keyup');
        }
        else {
            AmountInput.parents(".SepetRow").find(".ItemDelete .RemoveIcon").trigger("click");
        }
    });

    $(document).on("click", ".OrderBasketContainer .SepetRow .ItemDelete .RemoveIcon", function () {
        var ItemID = $(this).attr("data-id");
        var LangID = $("#LangID").val();

        RemoveFromCart(ItemID, LangID);
    });
    // #endregion

    $(document).on("change", ".GiftArea #GiftPackageChk", function () {
        var wantGift = $(this).prop("checked");

        SetGift(wantGift, function (status) {
            if (status) {
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").show();
            }
            else {
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").hide();
                $(".OrderContentDetails .GiftAndNoteContainer #OrderGiftNoteText").val("");
            }
        });
    });

    $(document).on("change", ".OrderCouponCodes #CouponChk", function () {
        $(".OrderCouponCodes .UseCouponOrder").toggleClass("d-none");
    });

    // #region Coupon
    $(document).on("click", ".CouponContainer .CouponCodeListArea .UseCoupon", function () {
        var CouponCode = $(this).parent().find(".myCoupons .custom-select option:selected").attr("data-code");

        if (CouponCode != null && CouponCode != "" && CouponCode != undefined && CouponCode != "0") {
            UseUserCoupon(CouponCode);
        }
        else {

            SwalGenerate("warning", getStandartMessages("LutfenKuponSecin"), getStandartMessages("Hata"), getStandartMessages("Kapat"));
        }
    });

    $(document).on("click", ".SummaryContainer .SummaryBody .DeleteCoupon", function () {
        DeleteUserCoupon();
    });

    $(document).on("click", ".CouponContainer .OrderCouponCodes #UseCoupon", function () {
        CouponCode = $(".CouponContainer #CouponCodeInput").val();

        if (CouponCode != null && CouponCode != "" && CouponCode != undefined) {
            UseUserCoupon(CouponCode);
        }
    });
    // #endregion
}

function LoginRegisterModalEvents() {
    $('#LoginRegisterModal').on('hide.bs.modal', function () {
        $("#LoginRegisterModal .LoginForm").trigger("reset");
        $("#LoginRegisterModal .RegisterForm").trigger("reset");
        $("#LoginRegisterModal .ForgettenForm").trigger("reset");
    });

    $(document).on("click", "#CheckoutHeader .Popup, .OrderContentDetails .RegisterForCoupon .LoginRegister", function (e) {
        var event = $(this).attr("data-event");

        if (event == "login") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
        }
        else if (event == "register") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").show();
        }

        return false;
    });

    $(document).on("click", "#LoginRegisterModal .NowRegister, #LoginRegisterModal .OpenLoginPanel, #LoginRegisterModal .ForgetPass, #LoginRegisterModal .CancelForgettenPass", function (e) {
        var event = $(this).attr("data-event");

        if ($(this).hasClass("NowRegister")) {
            $("#LoginRegisterModal .RegisterPanel").show();
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
        }
        else if ($(this).hasClass("OpenLoginPanel") || $(this).hasClass("CancelForgettenPass")) {
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
        }
        else {
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").show();
        }

        return false;
    });

    $(document).on("click", "#LoginRegisterModal .ContinueWithoutMember", function (e) {
        SetMemberless();
    });

    $(document).on("submit", "#LoginRegisterModal form.LoginForm, #LoginRegisterModal form.RegisterForm, #LoginRegisterModal form.ForgettenForm", function () {
        LoginRegisterFormSubmit($(this));

        return false;
    });
}

function AddressPageEvents() {
    //if ($("#CurStep").val() == "Adres") {
    //    SetCargoPrice();
    //}

    // SelectAddresTypeCheck

    $(document).on("change", ".OrderContentDetails .SelectAddresTypeCheck .CustomCheckbox input[type='radio']", function () {
        if ($(this).prop("checked") == true) {
            $(".row.BillingAddress").addClass("d-none");

            var setID = $(".OrderContentDetails .DeliveryAddress .AddressContainer .CustomCheckbox.selected .checkable").attr("data-id");
            SetAddress(setID, "Delivery", true);
        }
        else {
            $(".row.BillingAddress").removeClass("d-none");
        }
    });

    $(document).on("click", ".OrderContentDetails .AddressContainer .CustomCheckbox .checkable", function () {
        var id = $(this).attr("data-id");
        var type = "Delivery";
        var typeClass = ".DeliveryAddress";

        if ($(this).closest(".BillingAddress").length > 0) {
            type = "Billing";
            typeClass = ".BillingAddress";
        }

        var isAllSelected = $(".OrderContentDetails .SelectAddresTypeCheck .CustomCheckbox").hasClass("selected");

        if (isAllSelected) {
            $(".DeliveryAddress .AddressContainer .CustomCheckbox").removeClass("selected");
            $(".DeliveryAddress .AddressContainer .CustomCheckbox input").prop("checked", false);
            $(".DeliveryAddress .AddressContainer .CustomCheckbox label").removeClass("c_on");
        }
        else {
            $(typeClass + " .AddressContainer .CustomCheckbox").removeClass("selected");
            $(typeClass + " .AddressContainer .CustomCheckbox input").prop("checked", false);
            $(typeClass + " .AddressContainer .CustomCheckbox label").removeClass("c_on");
        }

        SetAddress(id, type, isAllSelected);
    });

    $(document).on("click", ".AddressContainer .NewAddress", function () {
        AddressModal = $("#AddressAddModal");

        AddressModal.modal("show");
        ModalHideEvent(AddressModal, ".modal-body");

        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

        GetPartialAdress(AddressModal);
    });

    $(document).on("click", ".AddressContainer .AddressBox .AddressOperation .AddressEdit", function () {
        AddressModal = $("#AddressAddModal");
        var id = $(this).attr("data-id");

        if (id != undefined && id != "" && id > 0) {
            AddressModal.modal("show");
            ModalHideEvent(AddressModal, ".modal-body");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

            var EditUrl = getRequestRoute() + "/p/CheckOutAddress/EditOrCreate?id=" + id;

            GetPartialAdress(AddressModal, EditUrl);
        }
        else {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }
    });

    $(document).on("click", ".AddressContainer .AddressBox .AddressOperation .AddressDelete", function () {
        var id = $(this).attr("data-id");
        var AddressContainer = $(this).parents(".AddressContainer");

        if (id != undefined && id != "" && id > 0) {
            DeleteAddress(id, AddressContainer);
        }
        else {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }
    });

    $(document).on("click", "#CargoTable tbody tr", function () {
        var CargoPriceID = $(this).find(".OrderRadio input").val();

        if (CargoPriceID != null && CargoPriceID != "" && CargoPriceID != undefined && CargoPriceID > 0) {
            SetCargoPrice(CargoPriceID);
        }
    });

    // #region Address Modal Events
    $('#AddressAddModal').on('hide.bs.modal', function () {
        $("#AddressAddModal form").trigger("reset");
    });

    $('#AddressAddModal').on('show.bs.modal', function () {
        $("#AddressAddModal form").trigger("reset");

        var countryCode = getCookie("Service_GeoLocation:SelectedCountryCode:");

        if (countryCode == "TR") {
            $("#AddressAddModal #Phone2").mask("999 999 99 99", {
                translation: {
                    'Z': {
                        pattern: "^[0-9]+$", optional: false
                    }
                }
            });

            $("#AddressAddModal #Tcno").mask("99999999999", {
                translation: {
                    'Z': {
                        pattern: "^[0-9]+$", optional: false
                    }
                }
            });

            $(document).on("keyup", "#AddressAddModal #Phone2", function () {
                var phone = $(this).val();
                var firstChar = phone.substr(0, 1);

                if (firstChar == "0") {
                    phone = phone.substr(1, phone.length);
                    $(this).val(phone);
                }
            });
        }
        else if (countryCode == "RU") {
            $("#AddressAddModal #Phone2").mask("99999999999", {
                translation: {
                    'Z': {
                        pattern: "^[0-9]+$", optional: false
                    }
                }
            });
        }
    });

    $(document).on("click", "#AddressAddModal .FormButtons .btn-cancel", function () {
        $("#AddressAddModal").modal("hide");
    });

    $(document).on("change", "#AddressAddModal .ddl_sehir", function () {
        AddressModal = $("#AddressAddModal");
        var seciliSehirOID = $(this).val();

        if (seciliSehirOID != undefined && seciliSehirOID != "" && seciliSehirOID != undefined) {
            GetDistrict(seciliSehirOID);
        }
        else {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            $('#TownID option:gt(0)').remove();
        }
    });

    $(document).on("change", "#AddressAddModal .ddl_state", function () {
        AddressModal = $("#AddressAddModal");

        var seciliStateOID = $(this).val();

        if (seciliStateOID != undefined && seciliStateOID != "" && seciliStateOID != undefined) {
            GetStateCity(seciliStateOID);
        }
        else {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            $('#CityID option:gt(0)').remove();
        }
    });

    $(document).on("submit", "#AddressAddModal form.OrderAdressForm", function () {
        form = $(this);
        GenerateLocalLoading(form, "show");

        AddAddress(form);

        return false;
    });

    $(document).on("change", ".adrestipradio", function () {
        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
        }
        else {
            $(".vergi").hide("slow");
        }
    });
    // #endregion
}

function PaymentPageEvents() {
    // #region Agreement
    ModalHideEvent($('#AgreementModal'), ".modal-body");

    $(document).on("click", "#AgreementModal .modal-footer .btn-ok", function () {
        $("#AgreementModal").modal("hide");
    });

    $(document).on("click", "#OrderSummary .SummaryAgrement .CustomCheckbox", function () {
        var IsCheck = $(this).find("input[name='Agrement']").prop("checked");

        SetAgreement(!IsCheck);
    });

    if (isMobileResolution()) {
        $(document).on("click", ".OrderContentDetails #Agreement > div > .AgreementHeader", function () {
            $(this).parent().toggleClass("hideToggle");
            $(this).parent().children(".detail").toggleClass("toggle");
        });
    }
    // #endregion

    PaymentButtonControl();

    $lastSelectedBankID = "";
    $lastSelectedDoorID = "";
    $lastSelectedPosID = "";

    firstBin = "";
    lastBin = "";

    // #region Payment Accordion Events
    $('#PaymentAccordion').on('shown.bs.collapse', function () {
        selectedGroup = $(this).find(".panel-collapse.show").parent();

        var webposinstallmentid = selectedGroup.find(".PaymentTitle").attr("data-webposinstallment-id");
        var bankid = selectedGroup.find(".PaymentTitle").attr("data-bankid");

        SetPaymentType(webposinstallmentid, bankid, function (status, dt) {
            if (status == true) {
                RefreshOrderSummary(false);
            }
            else {
                SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    });

    $('#PaymentAccordion').on('show.bs.collapse', function (e) {
        selectedGroup = $(document).find("[data-target='#" + $(e.target).attr('id') + "']").parents(".accordion-item");

        // #region Default Select
        // Girogate Input Seçili Gelmesi
        selectedGroup.find(".GirogateOdemeTuru").first().prop("checked", true);
        // END Girogate Input Seçili Gelmesi

        // Kapıda Ödeme Input Seçili Gelmesi        
        selectedGroup.find(".KapidaOdemeTuru").first().prop("checked", true);
        $lastSelectedDoorID = selectedGroup.find(".KapidaOdemeTuru").first().attr("data-webposinstallment-id");
        // END Kapıda Ödeme Input Seçili Gelmesi

        // Havale Input Seçili Gelmesi        
        selectedGroup.find(".BankID").first().prop("checked", true);
        $lastSelectedBankID = selectedGroup.find(".BankID").first().attr("data-webposinstallment-id");
        // END Havale Input Seçili Gelmesi

        // Web Pos Input Secili Gelmesi

        // Web Pos Input Secili Gelmesi
        selectedGroup.find(".WebPosItem.DefaultPos .WebPosItemInput").first().prop("checked", true);
        $lastSelectedPosID = selectedGroup.find(".WebPosItem.DefaultPos .WebPosItemInput").first().attr("data-webposinstallment-id");
        //$("#CardForm").trigger("reset");

        // #endregion
    });

    $("#PaymentAccordion").on("hidden.bs.collapse", function () {
        PaymentButtonControl();
    });
    // #endregion

    // #region Credit/Debit Card
    $(document).on("click", ".accordion-item .OnlinePos .Installments table tbody tr", function () {
        Input = $(this).find("input[type='radio']");

        var WebPosInsID = Input.attr("data-webposinstallment-id");

        if (WebPosInsID != null && WebPosInsID != "" && WebPosInsID != undefined && WebPosInsID > 0 && $lastSelectedPosID != WebPosInsID) {
            SetPaymentType(WebPosInsID, 0, function (status, dt) {
                if (status == true) {
                    RefreshOrderSummary(false);
                }
                else {
                    SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            });

            $lastSelectedPosID = WebPosInsID;
            Input.prop("checked", true);
        }
    });

    $(document).on("keyup", "#CardNumbers input", function (e) {
        // #region Card Number Format
        var cr_1 = $("#CardNumbers input#CardNumber1").val().replace(/\D/g, '');
        cr_1 = formatCCnumber(cr_1);

        $("#CardNumbers input#CardNumber1").val(cr_1);
        //#endregion

        var cardNumber = cr_1.replace(/\D/g, '');
        isAllValid = false;

        $lastCardType = "";

        var result = $(this).validateCreditCard({
            accept: ['visa', 'visa_electron', 'mastercard', 'amex', 'maestro']
        });

        if (result != null && result != undefined /*&& cardNumber.length >= 15*/) {
            if (!result.valid) {
                $("#CardNumbers input").addClass("NotValid");
                $("#CardNumbers .cardType").addClass("NotValid").removeClass("Valid");

                if ($lastCardType != "") {
                    $("#CardNumbers .cardType").removeAttr($lastCardType);
                }

                $("#CardForm .cvc").attr("maxlength", "3");

                if ($(".cvc").val().length > 3) {
                    $(".cvc").val("");
                }

                isAllValid = false;
            }
            else {
                $("#CardNumbers input").removeClass("NotValid");
                $("#CardNumbers .cardType").removeClass("NotValid").addClass("Valid");

                $lastCardType = result.card_type.name;
                $("#CardNumbers .cardType").attr("cart_type", result.card_type.name);

                if (result.card_type.name == "amex") {
                    $("#CardForm .cvc").attr("maxlength", "4");
                }
                else {
                    $("#CardForm .cvc").attr("maxlength", "3");

                    if ($(".cvc").val().length > 3) {
                        $(".cvc").val("");
                    }
                }

                isAllValid = true;
            }
        }
        else {
            $("#CardNumbers input").addClass("NotValid");
            $("#CardNumbers .cardType").addClass("NotValid").removeClass("Valid");

            if ($lastCardType != "") {
                $("#CardNumbers .cardType").removeAttr($lastCardType);
            }

            $("#CardForm .cvc").attr("maxlength", "3");

            if ($(".cvc").val().length > 3) {
                $(".cvc").val("");
            }

            isAllValid = false;
        }

        CheckBinNumber();
        PaymentButtonControl();
    });
    // #endregion

    // #region Money Transfer & Pay At Door
    $(document).on("click", ".accordion-item #BankList .BankItem", function () {
        Input = $(this).find("input[type='radio']");

        var bankID = Input.attr("data-bankid");
        var WebPosInsID = Input.attr("data-webposinstallment-id");

        if ($lastSelectedBankID != WebPosInsID) {
            if (bankID != null && bankID != "" && bankID != undefined && bankID > 0
                && WebPosInsID != null && WebPosInsID != "" && WebPosInsID != undefined && WebPosInsID > 0) {
                SetPaymentType(WebPosInsID, bankID, function (status, dt) {
                    if (status == true) {
                        RefreshOrderSummary(false);
                    }
                    else {
                        SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    }
                });
            }

            $lastSelectedBankID = WebPosInsID;
            Input.prop("checked", true);
        }
    });

    $(document).on("click", ".accordion-item .PayAtDoorList .DoorItem", function () {
        var id = $(this).find("input[type='radio']").attr("data-webposinstallment-id");

        if ($lastSelectedDoorID != id) {
            SetPayAtDoorType(id);
            $lastSelectedDoorID = id;
        }
    });
    // #endregion

    var pageType = $("#PgType").val();

    if (pageType != undefined && pageType == "CheckOutOdeme") {
        $(document).on("click", "#nextbtn", function () {
            SizeAndMeUserKeyControl();
        });
    }
}

function SizeAndMeUserKeyControl() {

    var sizeAndMeUserKey = localStorage.getItem("SizeAndMeUserKey");

    if (sizeAndMeUserKey != undefined) {

        var sizeAndMe = "sizeandme";

        var sizeAndMeUserKey = localStorage.getItem("SizeAndMeUserKey");

        $.ajax({
            url: getRequestRoute() + "/p/User/SetUtmParam",
            data: "utm_source=" + sizeAndMe + "&utm_campaign=" + sizeAndMe + "&utm_medium=" + sizeAndMeUserKey,
            type: "POST",
            cache: false
        });
    }
}

function RegisterValidateForm() {
    if ($("form.RegisterForm").length > 0) {
        var emailRequired = $(".RegisterForm #register_UserName").attr("data-required");
        var emailValid = $(".RegisterForm #register_UserName").attr("data-valid");
        var nameRequired = $(".RegisterForm #register_Name").attr("data-required");
        var GsmRequired = $(".RegisterForm #register_Gsm").attr("data-required");
        var GsmValid = $(".RegisterForm #register_Gsm").attr("data-valid");
        var birthdayRequired = $(".RegisterForm #register_BirthDate").attr("data-required");
        var passRequired = $(".RegisterForm #register_Password").attr("data-required");

        var countryCode = getCookie("Service_GeoLocation:SelectedCountryCode:");

        var gsmLength = 14;

        if (countryCode != "TR") {
            gsmLength = 3;
        }

        $("form.RegisterForm").validate({
            rules: {
                "register.UserName": {
                    required: true,
                    email: true
                },
                "register.Name": {
                    required: true
                },
                "register.Gsm": {
                    required: true,
                    minlength: gsmLength
                },
                "register.BirthDate": "required",
                "register.Password": {
                    required: true,
                    minlength: 6
                }
            },
            messages: {
                "register.UserName": {
                    required: emailRequired,
                    email: emailValid
                },
                "register.Name": {
                    required: nameRequired
                },
                "register.Gsm": {
                    required: GsmRequired,
                    minlength: GsmValid
                },
                "register.BirthDate": {
                    required: birthdayRequired
                },
                "register.Password": {
                    required: passRequired,
                    minlength: passRequired
                }
            }
        });
    }
}

function CountryControl() {
    var lastCountry = $.cookie("checkoutCountry");

    if (lastCountry != null && lastCountry != undefined && lastCountry != "" && $("#CurStep").length > 0 && $("#CurStep").val() != "Sepet") {
        if (lastCountry != $("#SmallCountryCode").val()) {
            GenerateLocalLoading($("body"), "show");
            document.location.href = getRequestRoute() + "/p/Checkout/sepet?rf=sepet";
        }
    }

    $.cookie("checkoutCountry", $("#SmallCountryCode").val(), { path: '/' }, { expires: 1 });
}

function KvkkModal() {
    $(document).on("click", ".KVKKTrigger", function () {
        $("#KVKKModal").modal();
    });
}

$(document).ready(function () {
    if ($("body").hasClass("CheckOut")) {
        ReloadOnTimeOut();
    }

    KvkkModal();
    //CountryControl();
    BasketPageClickEvents();
    LoginRegisterModalEvents();
    AddressPageEvents();
    PaymentPageEvents();
    //RegisterValidateForm();

    document.documentElement.setAttribute("data-browser", navigator.userAgent);

    if ($("#CurStep").length > 0) {
        PrepareAddressAndPayment($("#CurStep").val());

        if ($("#CurStep").val() == "Adres") {

            if ($(".MyAddress .AdressListTable .tableBody .DetailTable").length <= 0) {
                $(".MyAddress .AdressListTable .NewAddress").trigger("click");
            }
        }
    }

    if ($("#CheckoutMessage").length > 0) {
        SwalGenerate("warning", $("#CheckoutMessage").val(), getStandartMessages("Hata"), getStandartMessages("Kapat"));
    }

    $(document).on("click", ".OrderProgress .progressbar li", function () {
        var step = $(this).attr("data-step");

        if (step != null && step != "" && step != undefined) {
            SetStep(step);
        }
    });

    $(document).on("click", "#OrderDetailArea #OrderSummary #nextbtn", function () {
        var adim = $(this).attr("data-next");
        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            document.location.href = href;
            return;
        }

        if ($(".PaymentDetail.OnlinePos").closest("#creditcard").hasClass("show") && adim == "progress") {
            SetCreditCartAndStep(adim);
        }
        else if ($(".PaymentDetail.OnlinePos").closest("#masterpass").hasClass("show") && adim == "progress") {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "eec.checkout",
                "ecommerce": {
                    "checkout": {
                        "actionField": {
                            "step": "3",
                            "option": "Kredi Kartı"
                        }
                    }
                }
            });

            if (masterpass.UserMasterpass() == true) {
                masterpass.SetMasterPassCartAndStep();
            }
            else {
                masterpass.SetStandartPayment(adim);
            }
        }
        else if (adim == "progress" && !$("#PaymentAccordion .accordion-item .panel-collapse").hasClass("show")) {
            SwalGenerate("error", getStandartMessages("DevamEtmekIcınOdemeYontemi"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }
        else {
            SetStep(adim);
        }
    });

    $(document).on("click", ".CustomCheckbox:not(.noWorking)", function () {
        li = $(this);

        if (li.hasClass("selected")) {
            li.find("input").prop('checked', false);
            li.removeClass("selected");
            li.find("label").removeClass("c_on");
        }
        else {
            li.find("input").prop('checked', true);
            li.addClass("selected");
            li.find("label").addClass("c_on");
        }

        li.find("input").trigger("change");
    });


    // Mobil satın alma butonunun aşağıya sabitlenmesi
    if ($(window).width() < 991) {
        $(window).scrollTop($(window).scrollTop() + 1);
        var deviceHeight = $(window).height();

        $(window).scroll(function () {
            var top = $("#SummaryNextBackButtons").offset().top;

            if (($(window).scrollTop() + deviceHeight) > top) {
                $("#SummaryNextBackButtons .SummaryButtonRow").removeClass("fixed");
            }
            else {
                $("#SummaryNextBackButtons .SummaryButtonRow").addClass("fixed");
            }
        });
    }

    if ($("#LoginRegisterModal input[id='Gsm']").length > 0) {
        $("#Gsm").mask("999 999 99 99", {
            translation: {
                'Z': {
                    pattern: /[0-9]/, optional: true
                }
            }
        });

        $(document).on("keyup", "#Gsm", function () {
            var phone = $(this).val();
            var firstChar = phone.substr(0, 1);

            if (firstChar != "5") {
                $(this).val("");
            }
        });
    }

});